import isArray from "lodash/isArray";
import Pivot from "views/logic/aggregationbuilder/Pivot";
export default (fieldName, type) => {
  const fields = isArray(fieldName) ? fieldName : [fieldName];
  switch (type.type) {
    case "date":
      return Pivot.create(fields, "time", { interval: { type: "auto", scaling: 1 } });
    default:
      return Pivot.createValues(fields);
  }
};
